import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { CheckCircle, XCircle } from "@phosphor-icons/react";

export default function VerifyEmailPage() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const [status, setStatus] = useState("verifying"); // verifying | success | error
    const [error, setError] = useState("");
    const attempted = useRef(false);

    useEffect(() => {
        if (attempted.current) return;
        attempted.current = true;
        if (!token) {
            setStatus("error");
            setError("Missing verification token.");
            return;
        }
        (async () => {
            try {
                await api.post("/auth/verify-email/confirm", { token });
                setStatus("success");
            } catch (err) {
                setStatus("error");
                setError(formatApiError(err.response?.data?.detail) || err.message);
            }
        })();
    }, [token]);

    return (
        <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-4 py-12" data-testid="verify-email-page">
            <div className="w-full max-w-md bg-white border border-stone-200 rounded-xl p-8 text-center">
                {status === "verifying" && (
                    <div data-testid="verify-loading">
                        <div className="text-stone-500 text-sm font-mono uppercase tracking-[0.2em]">Verifying…</div>
                    </div>
                )}
                {status === "success" && (
                    <div data-testid="verify-success">
                        <div className="w-14 h-14 rounded-full bg-[#FFF4CC] border border-[#FFE680] flex items-center justify-center mx-auto mb-4">
                            <CheckCircle size={26} className="text-[#7A0000]" weight="fill" />
                        </div>
                        <h1 className="font-heading text-2xl font-bold text-[#0A0A0A] mb-2 tracking-tight">Email verified</h1>
                        <p className="text-stone-500 text-sm mb-6">Welcome to the Trojan travel circle. You can now make the most of TrojanTrails.</p>
                        <Link to="/feed" data-testid="verify-feed-link"
                              className="inline-flex items-center px-5 h-10 rounded-lg bg-[#990000] text-white hover:bg-[#7A0000] text-sm font-medium">
                            Go to feed
                        </Link>
                    </div>
                )}
                {status === "error" && (
                    <div data-testid="verify-error">
                        <div className="w-14 h-14 rounded-full bg-[#990000]/10 flex items-center justify-center mx-auto mb-4">
                            <XCircle size={26} className="text-[#990000]" weight="fill" />
                        </div>
                        <h1 className="font-heading text-2xl font-bold text-[#0A0A0A] mb-2 tracking-tight">Verification failed</h1>
                        <p className="text-stone-500 text-sm mb-6">{error}</p>
                        <Link to="/feed" className="inline-flex items-center px-5 h-10 rounded-lg bg-[#990000] text-white hover:bg-[#7A0000] text-sm font-medium">
                            Continue to feed
                        </Link>
                    </div>
                )}
            </div>
        </div>
    );
}
